import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
export function getMultiSectionDigitalClockSectionUtilityClass(slot) {
  return generateUtilityClass('MuiMultiSectionDigitalClock', slot);
}
export const multiSectionDigitalClockSectionClasses = generateUtilityClasses('MuiMultiSectionDigitalClock', ['root', 'item']);